import Button from 'components/base/Button';
import { Col, Form, Row } from 'react-bootstrap';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import { pago_sueldo_inicial, Pago_sueldo } from 'data/pagos/pagoSueldo';

const CreatePagoSueldo = () => {
  const navigate = useNavigate();
  const [pagoSueldo, setPagoSueldo] = useState<Pago_sueldo>(pago_sueldo_inicial);
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000'; 
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getFormattedDate = () => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0'); // Get day, pad with leading zero
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11, so +1), pad with leading zero
    const year = String(date.getFullYear()).slice(-2); // Get last two digits of year
    return `${day}-${month}-${year}`;
  };

  const handleImporteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPagoSueldo(prev => ({ ...prev, importe: Number(event.target.value) || 0 }));
  };

  const handleNotaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setPagoSueldo(prev => ({ ...prev, notas: event.target.value }));
  };

  const handlePagaChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setPagoSueldo(prev => ({ ...prev, paga: event.target.value }));
  };

  const handleCobraSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setPagoSueldo(prev => ({ ...prev, cobra: event.target.value, nombre_pago: event.target.value + ', '+ getFormattedDate() }));
  };

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const pagoSueldo4Submit = {
        cobra: pagoSueldo.cobra,
        nombre_pago	: pagoSueldo.nombre_pago,			
        importe	: pagoSueldo.importe,
        paga:pagoSueldo.paga,
        notas: pagoSueldo.notas
    }

    try {
      const response = await axios.post(`${apiUrl}/pagosSueldos/store`, pagoSueldo4Submit);
      console.log('Pago created with ID:', response.data);
      navigate('/apps/pagos/pagos-sueldos-list-view'); // Adjust route as needed
    } catch (error) {
      console.error(
        'Error creating pago de sueldo:',
        (error as AxiosError).response?.data || (error as AxiosError).message
      );
    }
    finally {
    setIsSubmitting(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="mb-4">Crear un Pago de Sueldo: {pagoSueldo.nombre_pago}</h2>
      <Row as="form" className="g-3 mb-6">
        <Col sm={6} md={4}>
          <Form.Label> Sueldo</Form.Label>
          <Form.Select
            size="lg"
            onChange={handleCobraSelectChange}
          >
            <option value=""> </option>
            <option value='CAP'>CAP</option>
            <option value='EA'>EA</option>
            <option value='FAM'>FAM</option>
            <option value='GEO'>GEO</option>
            <option value='IS'>IS</option>
            <option value='ISV'>ISV</option>
            <option value='LA'>LA</option>
            <option value='MSJ'>MSJ</option>
            <option value='SAG'>SAG</option>
            <option value='SSN'>SMN</option>
            <option value='ZCC'>ZCC</option>
          </Form.Select>
        </Col>

        <Col sm={6} md={4}>
          <Form.Label>Importe</Form.Label>
          <Form.Control
            size="lg"
            type="number"
            onChange={handleImporteChange}
          />
        </Col>

        <Col sm={6} md={4}>
          <Form.Label>Quien Paga</Form.Label>
          <Form.Select
            size="lg"
            onChange={handlePagaChange}
          >
            <option value=""> </option>
            <option value='CAP'>CAP</option>
            <option value='GEO'>GEO</option>
            <option value='IS'>IS</option>
            <option value='ISV'>ISV</option>
            <option value='LA'>LA</option>
            <option value='SAG'>SAG</option>
            <option value='ZCC'>ZCC</option>          
            </Form.Select>
        </Col>

        <Col sm={6} md={4}>
          <Form.Label>Notas</Form.Label>
          <Form.Control
            as="textarea"
            size="lg"
            onChange={handleNotaChange}
            //style={{ height: '100px' }}
          />
        </Col>

        <Col xs={12} className="d-flex justify-content-end gap-3">
          <Button
            variant="secondary"
            className="px-5"
            onClick={() => navigate(-1)}
          >
            Cancelar
          </Button>
          <Button 
            variant="primary" 
            className="px-5" 
            onClick={handleSubmit}
            disabled={isSubmitting}
            >
            {isSubmitting ? 'Guardando...' : 'Guardar'}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default CreatePagoSueldo;